import { SketchPicker } from "react-color";

/** SketchPicker crashes if color is null/undefined (reads .hex). */
function safeColorValue(color) {
  if (color == null) return "#ffffff";
  const s = String(color).trim();
  if (!s || s === "null" || s === "undefined") return "#ffffff";
  return s;
}

const ColorPicker = ({ setColor, color }) => {
  const handleChange = (next) => {
    if (setColor && next?.hex) {
      setColor(next.hex);
    }
  };

  return (
    <div
      className="choose-picker-inner"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <SketchPicker
        color={safeColorValue(color)}
        onChangeComplete={handleChange}
      />
    </div>
  );
};

export default ColorPicker;
